module.exports = __webpack_public_path__ + "static/media/seguradora_esse.4c1433f1.png";